import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { styled } from '@stitches/react';

// 导入子页面组件（将在后续创建）
import KipaWalletOverview from './KipaWalletOverview';
import KipaWalletFeatures from './KipaWalletFeatures';
import KipaWalletSupport from './KipaWalletSupport';
import KipaWalletSecurity from './KipaWalletSecurity';

// Kipa钱包容器样式
const KipaWalletContainer = styled('div', {
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 1rem'
});

/**
 * Kipa钱包模块主组件
 * 管理Kipa钱包相关路由
 */
const KipaWallet: React.FC = () => {
  // const { t } = useTranslation(); // 暂时未使用
  
  return (
    <KipaWalletContainer>
      <Routes>
        <Route path="/" element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<KipaWalletOverview />} />
        
        {/* 钱包功能页面 */}
        <Route path="features" element={<KipaWalletFeatures />} />
        
        {/* 安全说明页面 */}
        <Route path="security" element={<KipaWalletSecurity />} />
        
        {/* 支持信息页面 */}
        <Route path="support" element={<KipaWalletSupport />} />
        
        {/* 重定向到钱包概览 */}
        <Route path="*" element={<Navigate to="/products/kipa-wallet" replace />} />
      </Routes>
    </KipaWalletContainer>
  );
};

export default KipaWallet; 